// Central site data: nav, services, partners, hours, etc.

export const SITE = {
  name: "Pratik Teknoloji",
  fullName: "Pratik Bilişim Teknolojileri Anonim Şirketi",
  phone: "+90 (286) 212 56 55",
  phoneRaw: "+902862125655",
  whatsapp: "+905456399099",
  whatsappRaw: "905456399099",
  email: "info@pratikteknoloji.tr",
  address: {
    line1: "İsmetpaşa Mahallesi, Demircioğlu Caddesi No:130",
    line2: "Premium Evleri, B Blok No:1",
    city: "Merkez / Çanakkale",
    zip: "17100",
  },
  foundedShort: "Haziran 2015",
  corporate: "19 Mart 2025 tarihinde Pratik Bilişim Teknolojileri A.Ş. unvanıyla kurumsal yapıya dönüştü.",
};

// Working hours schedule. day: 0=Sun ... 6=Sat
// Each day can have multiple intervals ({open, close} in HH:MM)
export const HOURS = {
  0: [], // Sunday closed
  1: [ { open: "09:00", close: "12:30" }, { open: "13:30", close: "18:00" } ],
  2: [ { open: "09:00", close: "12:30" }, { open: "13:30", close: "18:00" } ],
  3: [ { open: "09:00", close: "12:30" }, { open: "13:30", close: "18:00" } ],
  4: [ { open: "09:00", close: "12:30" }, { open: "13:30", close: "18:00" } ],
  5: [ { open: "09:00", close: "12:30" }, { open: "13:30", close: "18:00" } ],
  6: [ { open: "10:00", close: "12:30" }, { open: "13:30", close: "16:00" } ],
};

// Warning only on the LAST close of day (evening). We derive last close per day.
export const CLOSING_WARNING_MINUTES = 30;

export const NAV = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/hizmetler", label: "Hizmetler" },
  { to: "/is-ortaklari", label: "İş Ortakları" },
  { to: "/neden-biz", label: "Neden Biz" },
  { to: "/referanslar", label: "Referanslar" },
  { to: "/iletisim", label: "İletişim" },
];

export const PARTNERS = [
  { slug: "mikro", name: "Mikro Yazılım", logo: "/logos/mikro.png",
    desc: "ERP, muhasebe, perakende, üretim otomasyonları ve e-Dönüşüm çözümleri." },
  { slug: "elogo", name: "e-Logo", logo: "/logos/elogo.png",
    desc: "e-Fatura, e-Arşiv, e-İrsaliye, e-Defter Saklama ve e-Dönüşüm çözümleri." },
  { slug: "flap", name: "Flap Yazılım", logo: "/logos/flap.png",
    desc: "Restaurant otomasyon sistemleri, perakende ve saha operasyon yönetimi." },
  { slug: "mihsap", name: "Mihsap", logo: "/logos/mihsap.png",
    desc: "Mali müşavirler için robotik muhasebe yazılımı. Evrakları otomatik tarayın, işleyin ve arşivleyin. %70'e kadar maliyet tasarrufu." },
  { slug: "kalfa", name: "Kalfa", logo: "/logos/kalfa.png",
    desc: "Mali müşavirler için iş yükünü hafifleten, geliri artıran yenilikçi platform." },
  { slug: "akilli-ticaret", name: "Akıllı Ticaret", logo: "/logos/akilli-ticaret.png",
    desc: "E-ticaret altyapısı ve mağaza kurulumu." },
  { slug: "eguven", name: "e-Güven", logo: "/logos/eguven.png",
    desc: "E-imza, KEP ve dijital sertifika hizmetleri." },
];

export const SERVICES = [
  {
    slug: "yazilim-cozumleri",
    title: "Yazılım Çözümleri",
    short: "ERP, muhasebe, üretim, perakende ve e-Dönüşüm süreçlerini yöneten profesyonel yazılımlar.",
    tag: "01",
    accent: "red",
    bullets: [
      "Mikro Yazılım ERP, muhasebe ve perakende çözümleri",
      "e-Logo ile e-Fatura, e-Arşiv, e-İrsaliye",
      "Flap Yazılım saha ve perakende otomasyonu",
      "Mihsap ön muhasebe ve işletme yönetimi",
      "Kalfa bulut tabanlı ticari yazılım",
    ],
    long: "İşletmenizin büyüklüğünden bağımsız olarak; muhasebe, stok, üretim, perakende ve e-Dönüşüm süreçlerini uçtan uca yönetebileceğiniz profesyonel yazılım altyapılarını kuruyor, kuruluyor ve destekliyoruz. Kurumsal yapımızla iş ortaklarımızın tüm yetkili hizmetlerini tek merkezden alırsınız; amatör ruhumuzla da her sorunuzu ilk günkü heyecanla çözeriz.",
  },
  {
    slug: "pos-sistemleri",
    title: "POS Sistemleri",
    short: "Endüstriyel dokunmatik POS PC'ler, restoran, market ve kafe çözümleri.",
    tag: "02",
    accent: "blue",
    bullets: [
      "Endüstriyel dokunmatik POS PC'ler",
      "Restoran, market ve kafe çözümleri",
      "Hızlı satış sistemleri",
      "Terazi entegrasyonları",
      "Barkod ve yazarkasa uyumluluğu",
    ],
    long: "İşletmenizin akışına uyum sağlayan POS sistemleri kuruyoruz. İhtiyaca, bütçeye ve lokasyona göre en doğru donanım seçimini yapar, kurulum ve eğitim dahil teslim ederiz.",
  },
  {
    slug: "barkod-sistemleri",
    title: "Barkod Sistemleri",
    short: "Barkod yazıcılar, okuyucular, el terminalleri ve depo & stok yönetim çözümleri.",
    tag: "03",
    accent: "green",
    bullets: [
      "Barkod yazıcılar (masaüstü & endüstriyel)",
      "1D / 2D barkod okuyucular",
      "El terminalleri (Android & Windows CE)",
      "Depo ve stok yönetimi",
      "Perakende otomasyon çözümleri",
    ],
    long: "Stok doğruluğunu yüzde yüze taşıyan barkod ve el terminali projeleri tasarlıyoruz. Projeye en uygun cihaz, yazılım ve entegrasyonu sağlarız.",
  },
  {
    slug: "guvenlik-sistemleri",
    title: "Güvenlik Sistemleri",
    short: "IP kamera, NVR kayıt, alarm sistemleri ve uzaktan izleme çözümleri.",
    tag: "04",
    accent: "red",
    bullets: [
      "IP kamera sistemleri",
      "NVR kayıt çözümleri",
      "Alarm sistemleri",
      "Uzaktan izleme",
      "Analog → IP dönüşüm",
    ],
    long: "İşletmenizin tüm lokasyonlarını 7/24 güvence altına alacak kamera, kayıt ve alarm altyapılarını kuruyoruz. İhtiyaca göre en uygun sistemi planlıyor ve devreye alıyoruz.",
  },
  {
    slug: "teknik-servis",
    title: "Teknik Servis",
    short: "Yerinde servis, uzaktan destek, acil müdahale ve SLA anlaşmalı bakım hizmetleri.",
    tag: "05",
    accent: "blue",
    bullets: [
      "Yerinde servis",
      "Uzaktan destek",
      "Acil müdahale",
      "Periyodik bakım",
      "SLA seçenekleri",
    ],
    long: "Kurumsal hizmet standartlarımızla çalışıyoruz; ama içimizdeki amatör ruhu kaybetmeden, her zaman aynı heyecanla yanınızdayız. Hattımız bir tuşla açılır; sorunuz saha ekibi tarafından aynı gün, uzaktan destek ekibimiz tarafından dakikalar içinde ele alınır.",
  },
  {
    slug: "sunucu-kiralama",
    title: "Sunucu Kiralama",
    short: "Kendi VPN altyapımız üzerinde çalışan, güvenli ve yüksek performanslı sunucu kiralama.",
    tag: "06",
    accent: "black",
    featured: true,
    bullets: [
      "Kapalı devre güvenli VPN altyapısı",
      "%99 uptime, düşük gecikme",
      "CPU, RAM, depolama özelleştirmesi",
      "ERP / muhasebe / perakende optimizasyonu",
      "Çok şubeli yapılara özel bağlantı",
      "Yedekleme seçenekleri",
    ],
    long: "Pratik Bilişim Teknolojileri A.Ş. olarak işletmelerin kritik uygulamalarını, verilerini ve operasyonlarını güvenle barındırabilmeleri için yüksek performanslı sunucu kiralama hizmeti sunuyoruz. Tüm altyapımız kendi VPN mimarimiz üzerinde çalışır; verileriniz dış ağlara açık olmaz, bağlantılarınız şifrelenir, yetkisiz erişim engellenir, şubeler arası güvenli iletişim sağlanır. Güvenli, hızlı, stabil ve ölçeklenebilir bir sunucu altyapısı arıyorsanız, sunucu kiralama hizmetimiz işletmenize tam uyum sağlar.",
  },
  {
    slug: "e-ticaret",
    title: "E-Ticaret Çözümleri",
    short: "Akıllı Ticaret altyapısı, ürün yönetimi, ödeme ve kargo entegrasyonları, SEO uyumlu mağaza.",
    tag: "07",
    accent: "blue",
    bullets: [
      "Akıllı Ticaret altyapısı",
      "Ürün ve kategori yönetimi",
      "Ödeme sistemleri entegrasyonu",
      "Kargo entegrasyonları",
      "SEO uyumlu mağaza kurulumu",
    ],
    long: "Fiziksel mağazanızı dijitale taşıyor, e-ticaret ekosisteminizi Akıllı Ticaret altyapısı üzerinde kuruyoruz. Ödeme, kargo, muhasebe ve pazaryeri entegrasyonları dahil — tek merkezden yönetin.",
  },
  {
    slug: "e-imza-kep",
    title: "E-İmza & KEP",
    short: "e-Güven bayiliği ile e-imza, KEP ve sertifika yenileme hizmetleri.",
    tag: "08",
    accent: "red",
    bullets: [
      "Nitelikli elektronik sertifika (e-imza)",
      "Kayıtlı Elektronik Posta (KEP)",
      "Sertifika yenileme",
      "Başvuru ve kurulum desteği",
    ],
    long: "e-Güven iş ortaklığımızla nitelikli e-imza, KEP ve dijital sertifika ihtiyaçlarınızı hızla karşılıyoruz. Başvurudan cihaz kurulumuna kadar tüm süreç bizde.",
  },
  {
    slug: "network-kurulum",
    title: "Network & Kurulum",
    short: "Kurumsal kablolu / kablosuz ağ altyapısı, switch, firewall ve VPN kurulumu.",
    tag: "09",
    accent: "green",
    bullets: [
      "Yapısal kablolama",
      "Kurumsal WiFi (mesh & controller)",
      "Firewall & güvenlik duvarı",
      "Site-to-site VPN",
      "Bant genişliği ve trafik optimizasyonu",
    ],
    long: "Ofisiniz, mağazanız veya şubeleriniz için uçtan uca network altyapıları tasarlıyoruz. Projeye en uygun switch, access point, firewall ve VPN çözümünü sunuyoruz.",
  },
];

export const VALUES = [
  { title: "Güvenilirlik", desc: "Söz verdiğimiz işi, söz verdiğimiz sürede ve kalitede teslim ederiz." },
  { title: "Profesyonellik", desc: "Her süreçte kurumsal standartlar; her iletişimde insani sıcaklık." },
  { title: "Hız", desc: "Sahada ve uzaktan destekte dakikalar içinde aksiyon." },
  { title: "Teknoloji Odaklılık", desc: "Global üreticilerle çalışır, en güncel çözümleri yerel uzmanlıkla sunarız." },
  { title: "Sürekli Gelişim", desc: "Her projede dünü geride bırakırız — öğrenmeyi hiç bırakmayız." },
  { title: "Müşteri Odaklılık", desc: "Çözümü biz üretiriz; kararı her zaman müşteri ile birlikte veririz." },
];

export const WHY_US = [
  { n: "01", title: "Güvenilirlik ve Şeffaflık", desc: "Tüm süreçlerimiz ölçümlenebilir, takip edilebilir ve şeffaftır." },
  { n: "02", title: "Teknik Yetkinlik ve Deneyim", desc: "Yazılım, donanım, güvenlik, network ve sunucu altyapılarında uzman ekipler." },
  { n: "03", title: "Hızlı ve Etkili Destek", desc: "Yerinde servis, uzaktan destek ve acil müdahale ekipleriyle kesintisiz operasyon." },
  { n: "04", title: "Güvenli ve Ölçeklenebilir Altyapı", desc: "Kapalı devre VPN mimarisi — yüksek güvenlik + yüksek performans." },
  { n: "05", title: "Global Standartlar, Yerel Uygulama", desc: "Global teknolojileri yerel uzmanlıkla birleştiriyoruz." },
  { n: "06", title: "Kurumsal Güç + Amatör Ruh", desc: "Profesyoneliz, kurumsalız; ama işimizi hâlâ ilk günkü heyecanla yapıyoruz." },
];

export const SOCIAL_LINKS = [
  { name: "Instagram", href: "#", icon: "instagram" },
  { name: "LinkedIn", href: "#", icon: "linkedin" },
  { name: "Facebook", href: "#", icon: "facebook" },
  { name: "X", href: "#", icon: "x" },
  { name: "YouTube", href: "#", icon: "youtube" },
];
